import { IVerificationResultByRecognition } from '../interfaces/verification-result-by-recognition';

export const VerificationResultByRecognition: IVerificationResultByRecognition =
  {
    title: 'Scan Error:',
    text: 'Cannot verify information',
  };

export const VerificationResultByRecognitionExpirationPassed: IVerificationResultByRecognition =
  {
    title: 'Expiration Passed:',
    text: 'This date has already passed',
  };
